<script>
import { Radar } from 'vue-chartjs'
export default {
    props:[],
    components:{

    },
    extends: Radar,
    data(){
        return{
            chartData:{
                dataCollection:{
                    labels: [
                        this.$t("components.ChartRadar.labels[0]"),
                        this.$t("components.ChartRadar.labels[1]"),
                        this.$t("components.ChartRadar.labels[2]"),
                        this.$t("components.ChartRadar.labels[3]"),
                        this.$t("components.ChartRadar.labels[4]"),
                        this.$t("components.ChartRadar.labels[5]"),
                        this.$t("components.ChartRadar.labels[6]"),
                        this.$t("components.ChartRadar.labels[7]"),
                        this.$t("components.ChartRadar.labels[8]"),
                        this.$t("components.ChartRadar.labels[9]")
                    ],

                    datasets: [
                        {
                            label: this.$t("components.ChartRadar.datasets.label"),
                            // backgroundColor: 'rgba(131, 3, 125, 0)',
                            backgroundColor: 'rgba(131, 3, 125, 0)',
                            borderColor: JSON.parse(localStorage.getItem("colors")).secondary,
                            pointBackgroundColor: JSON.parse(localStorage.getItem("colors")).secondary,
                            borderWidth: 4,
                            // data: [4, 3, 4, 4, 4, 1, 1, 1, 1, 1],
                            data: []
                        },
                        // {
                        //     label: 'Cenários',
                        //     backgroundColor: 'rgba(230, 230, 230, .7)',
                        //     borderColor: 'rgb(244, 244, 244)',
                        //     pointRadius: 0,
                        //     data: [1, 4, 3, 5, 3, 3, 4, 2, 2, 1],

                        // },
                    ],
                },
                options:{
                    responsive: true,
                    // maintainAspectRatio: true,
                    legend: {
                        display: false,
                        position: 'top',
                        labels: {
                            fontColor: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#fff' : '#000'
                        },
                    },                  
                    scale: {
                        pointLabels: {
                            fontColor: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#fff' : '#000', // labels around the edge like 'Running'
                            fontSize: 17,
                            font: {
                                size:100,
                            }
                        },
                        ticks: {
                            // display: false,
                            // showLabelBackdrop: false, // hide square behind text
                            maxTicksLimit: 6,
                            beginAtZero:true
                        },   
                        gridLines: {
                            color: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#414D58' : '#D3D3D3',
                            borderWidth: 2,
                        },          
                        angleLines: {
                            borderWidth: 2,
                            color: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#414D58' : '#D3D3D3'
                        }              
                    },
                },
            },
            url: `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}`,
            gameSetId: localStorage.getItem('gameSetId'),
            reportData: JSON.parse(localStorage.getItem('report')),
        }
    },

    created(){
        
        // let playStyle = Object.values(this.reportData.playStyle)
        let playStyle = [
            this.reportData.playStyle.methodical + 1 ,
            this.reportData.playStyle.persistent + 1,
            this.reportData.playStyle.analytic + 1,
            this.reportData.playStyle.lean + 1,
            this.reportData.playStyle.cautious + 1,
        ]
        // console.log('Play Style: ', this.reportData.playStyle)
        // console.log('Playstyle reordened: ', playStyle)
        this.populateRadar(playStyle)
    },
    
    mounted(){
        this.renderChart(this.chartData.dataCollection, this.chartData.options)
        // console.log(this.chartData.dataCollection)
    },

    methods:{
        populateRadar(reportData){
            let maxValue = 6
            let radarChart = reportData
            reportData.forEach(reportDataItem => {
                // radarData.push(maxValue - reportDataItem)
                radarChart.push(maxValue - reportDataItem)
            });
            this.chartData.dataCollection.datasets[0].data.push(
                radarChart[0],
                radarChart[9],
                radarChart[8],
                radarChart[7],
                radarChart[6],
                radarChart[5],
                radarChart[4],
                radarChart[3],
                radarChart[2],
                radarChart[1]
            )
            this.reportData.competencesArray = this.chartData.dataCollection.datasets[0].data
            localStorage.setItem('report', JSON.stringify(this.reportData))
            // console.log('Report Data', radarChart)
        }
    }
}
</script>

<style lang="scss" scoped>
    #chart-header{
        height: 79vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>